import { headerTabConstantValues, reversedHeaderConstants } from '../../components/Header/constants'
import { objectReversal } from '../../shared/utils'
import * as actionType from '../actionType'

const initialState = {
    headerTab: reversedHeaderConstants[(window.location.pathname).split('/')[1]],
}

const header = (state = initialState, action) => {
    switch (action.type) {
        case actionType.SET_HEADER_TAB: {
            return {
                ...state,
                headerTab: action.value,
            }
        }
        default:
            return state
    }
}

export default header
